import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { attachTimestampToFileName } from '@app/shared/utils/content-type.functions';
import { PreviewAnyFile } from '@awesome-cordova-plugins/preview-any-file/ngx';
import { ToastSandbox } from '../sandboxes/toast.sandbox';

const PERMISSION_DENIED_ERROR = 'Unable to do file operation, user denied permission request';
const NOT_CREATED_ERROR = 'FILE_NOTCREATED';

const GENERAL_ERROR_MESSAGE = 'error.preview-unavailable';
const PERMISSION_ERROR_MESSAGE = 'error.file-permission';

@Injectable({ providedIn: 'root' })
export class FileService {
  constructor(
    private toastSandbox: ToastSandbox,
    private previewAnyFile: PreviewAnyFile
  ) {}

  previewFile(data: Blob, filename: string, retried = false) {
    if (Capacitor.isNativePlatform()) {
      this.previewFileInNativeViewer(data, filename, retried);
    } else {
      this.previewFileInBrowser(data);
    }
  }

  private previewFileInBrowser(data: Blob) {
    const objectUrl = URL.createObjectURL(data);
    window.open(objectUrl, '_blank');
  }

  private async previewFileInNativeViewer(data: Blob, filename: string, retried = false) {
    try {
      const base64 = (await this.convertBlobToBase64(data)) as string;
      this.previewAnyFile.previewBase64(base64, { name: filename }).subscribe();
    } catch (e) {
      switch (e.message) {
        case PERMISSION_DENIED_ERROR: {
          this.toastSandbox.showErrorToast({key: PERMISSION_ERROR_MESSAGE});
          break;
        }
        case NOT_CREATED_ERROR: {
          //Need to stop recursive calls in case of repeated failures to save file with same error message
          if (!retried) {
            this.previewFileInNativeViewer(data, attachTimestampToFileName(filename, data.type), true);
          }
          break;
        }
        default: {
          this.toastSandbox.showErrorToast({key: GENERAL_ERROR_MESSAGE});
        }
      }
    }
  }

  convertBlobToBase64 = (image: Blob) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(image);
    });
}
